import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { projectPages } from "@/projects/projectPages";
import { getProjectSummary } from "@/projects/projectIndex";
import { trackContentPageView } from "@/lib/analytics";

function ProjectNotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-stem-cream">
      <div className="text-center px-4">
        <div className="w-20 h-20 rounded-full bg-stem-sand flex items-center justify-center mx-auto mb-6">
          <i className="ri-emotion-sad-line text-stem-gray text-3xl" />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-stem-dark mb-3">
          Project Not Found
        </h1>
        <p className="text-stem-gray mb-6">
          Hmm, I could not find that project. It might have been moved or
          deleted.
        </p>
        <button
          onClick={() => navigate("/projects")}
          className="btn-dark text-sm whitespace-nowrap"
        >
          <i className="ri-home-line" />
          Back to Projects
        </button>
      </div>
    </div>
  );
}

export default function ProjectPage() {
  const { id } = useParams<{ id: string }>();
  const { pathname, search, hash } = useLocation();
  const ProjectDetailPage = id ? projectPages[id] : undefined;
  const project = getProjectSummary(id);

  useEffect(() => {
    if (!project) return;

    window.requestAnimationFrame(() => {
      void trackContentPageView({
        path: `${pathname}${search}${hash}`,
        contentType: "project",
        contentId: project.id,
        contentTitle: project.title,
        contentCategory: project.category,
      });
    });
  }, [hash, pathname, project, search]);

  if (!ProjectDetailPage) {
    return <ProjectNotFound />;
  }

  return (
    <div className="min-h-screen bg-stem-cream">
      <Navbar />
      <main>
        <ProjectDetailPage />
      </main>
      <Footer />
    </div>
  );
}
